import { ChevronIcon } from "@images/svgIcons/chevronIcon"
import { word } from "@modules/core/utils/i18n"
import { PublicProfileDetails } from "@modules/profile/publicProfile/components/publicProfileDetails"
import { useUserProfile } from "@modules/profile/publicProfile/hooks/useUserProfile"
import { HuAvatarCardSidebar } from "@modules/ui/components/huAvatarCardSidebar"
import { HUButton } from "@modules/ui/components/huButton"
import { LoadingSpinner } from "@modules/ui/components/loading"
import { useState } from "react"
import { useTheme } from "styled-components"

type PublicProfileInfoResumeProps = {
  userId: string
}

export const PublicProfileInfoResume: React.FC<PublicProfileInfoResumeProps> = ({ userId }) => {
  const theme = useTheme()
  const [isBioCollapsed, setIsBioCollapsed] = useState<boolean>(true)

  const { data: viewedUser, isLoading } = useUserProfile(userId)

  const toggleBio = () => setIsBioCollapsed((value) => !value)

  return (
    <>
      {viewedUser ? (
        <div className="h-full" style={{ marginTop: "-85px" }}>
          <HuAvatarCardSidebar
            id={viewedUser.id}
            avatar={viewedUser.avatar}
            firstname={viewedUser.firstname}
            lastname={viewedUser.lastname}
            username={viewedUser.username}
            prefixUsername={viewedUser.username ? "@" : undefined}
            nationality={viewedUser.nationality}
            isLoading={isLoading}
            bottomButton={
              <HUButton
                data-testid="see-profile-details"
                type="Right_Icon"
                size="M"
                colorType="Underline"
                text={isBioCollapsed ? word("publicProfile.openProfile") : word("publicProfile.closeProfile")}
                onClick={toggleBio}
                icon={{
                  iconView: (
                    <ChevronIcon
                      color={theme.neutralColor900}
                      width={10}
                      height={10}
                      transform={isBioCollapsed ? "rotate(0)" : "rotate(180)"}
                    />
                  ),
                }}
              />
            }
          />
          <PublicProfileDetails publicProfile={viewedUser} isBioCollapsed={isBioCollapsed} isBioCollapsible={true} />
        </div>
      ) : (
        <LoadingSpinner />
      )}
    </>
  )
}
